import styled from '@emotion/styled';
import { FONT, COLORS3, SPACING } from '@zola/zola-ui/src/styles/emotion';

import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { Input } from '@zola/zola-ui/src/components/Form/inputV3/InputFieldV3/InputFieldV3.styles';
import { CheckboxField } from '@zola/zola-ui/src/components/Form/CheckboxField';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';

export const Container = styled.div``;

export const TitleFlex = styled.span`
  display: flex;
  align-items: flex-end;
`;

export const EditLink = styled(LinkV2)`
  margin-left: auto;
`;

export const ItemType = styled.small`
  color: ${COLORS3.BLACK_050};
  ${FONT.textSizeCompact(FONT.SIZE.EXTRA_SMALL)}
`;

export const CostContainer = styled.div`
  display: grid;
  grid-gap: ${SPACING.S24};
  grid-template-columns: 1fr 1fr;
`;

export const CostLabel = styled.label`
  ${FONT.textSizeCompact(FONT.SIZE.LARGE)}
  font-weight: ${FONT.WEIGHT.REGULAR};
  font-family: ${FONT.FAMILY.SANS_SERIF};
  margin-bottom: ${SPACING.XS};
  text-transform: none;
  letter-spacing: normal;
`;

export const CostFields = styled.div`
  ${Input} {
    text-align: right;
  }
`;

export const SuggestedAllocation = styled.div`
  color: ${COLORS3.BLACK_050};
  ${FONT.textSizeCompact(FONT.SIZE.EXTRA_SMALL)}
`;

export const StyledCheckboxField = styled(CheckboxField)`
  margin-top: ${SPACING.S16};

  .field-wrapper-checkbox {
    flex-direction: row-reverse;
  }
  .checkbox-icon-wrapper {
    margin-right: 0 !important;
    margin-left: ${SPACING.SM};
  }
  .selector-label-wrapper {
    text-align: right;
  }
`;

export const PaidRemaining = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${SPACING.S16} ${SPACING.S24};
  margin-top: ${SPACING.S16};
  margin-bottom: ${SPACING.LG};
  ${FONT.textSizeCompact(FONT.SIZE.SMALL)}
`;

export const PaidRemainingCurrency = styled.span`
  text-align: right;
`;

export const PaymentsHeader = styled.h2`
  margin: 0 0 ${SPACING.XS};
  font-weight: ${FONT.WEIGHT.REGULAR};
  ${FONT.textSizeCompact(FONT.SIZE.LARGE)}
`;

export const StyledP = styled.p`
  color: ${COLORS3.BLACK_100};
  ${FONT.textSizeCompact(FONT.SIZE.SMALL)}
`;

export const AddPaymentButton = styled(ButtonV3)`
  margin-top: ${SPACING.S16};
  margin-bottom: ${SPACING.LG};
`;

export const NotesLabel = styled.label`
  ${FONT.textSizeCompact(FONT.SIZE.LARGE)}
  font-weight: ${FONT.WEIGHT.REGULAR};
  font-family: ${FONT.FAMILY.SANS_SERIF};
  margin-bottom: ${SPACING.XS};
  text-transform: none;
  letter-spacing: normal;
  display: block;
`;

export const Optional = styled.span`
  ${FONT.textSizeCompact(FONT.SIZE.SMALL)}
  color: ${COLORS3.BLACK_050};
`;
